const IllustrationList = ["Doctor", "FacialRecognitionFingerprint", "HealthcarePersonnel", "ReadLetters", "Support2"];
const IllustrationSizeList = {
  Doctor: { small: "DoctorSmall", medium: "DoctorMedium" },
  FacialRecognitionFingerprint: { medium: "FacialRecognitionFingerprintMedium" },
  HealthcarePersonnel: { small: "HealthcarePersonnelSmall", medium: "HealthcarePersonnelMedium" },
  ReadLetters: { medium: "ReadLettersMedium" },
  Support2: { medium: "Support2Medium" }
};
export {
  IllustrationList,
  IllustrationSizeList
};
//# sourceMappingURL=IllustrationNames.js.map
